import { useMemo } from 'react';

import { type SiteWithPermissions } from '@sine/sine-core-api-types';

import { useSitesWithPermissionsQuery } from '../../../services/site/site.hooks';
import { AclAction } from '../../../team/permission/constants/actions';

export function useInvitationSiteOptions() {
  const { sites, isLoadingSites } = useSitesWithPermissionsQuery([AclAction.SIGN_IN, AclAction.H_PROFILE_PASS]);

  const allSites = useMemo(
    () => sites.filter((site) => site.settings.hostRequiredForSignIn || site.permissions.includes(AclAction.SIGN_IN)),
    [sites],
  );

  const siteOptions = useMemo(
    () =>
      allSites.map((site: SiteWithPermissions) => ({
        value: site.id,
        label: site.name,
        countryCode: site.countryCode,
      })),
    [allSites],
  );

  return {
    allSites,
    siteOptions,
    isLoadingInvitationSiteOptions: isLoadingSites,
  };
}
